import fieldMixin from '@maison/mixins/fieldMixin';

export default {
  mixins: [fieldMixin],

  props: {
    parentId: {
      type: String,
      default: '',
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    checkboxClasses() {
      return ['checkbox', { 'checkbox--invalid': this.isInvalid }];
    },

    ariaDescribedby() {
      return `${this.parentId}-label ${this.parentId}-error ${this.parentId}-help`;
    },
  },
};
